import { useCallback, useContext} from 'react';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import { ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';

function useTypelistUtil(xCenter, typelistName){
    const viewModelService = useContext(ViewModelServiceContext);

    const typelistCodes = viewModelService?.productMetadata.get(xCenter).types.getTypelist(typelistName).codes;
                     // viewModelService.productMetadata.get('pc').types.getTypelist('typekey.DocumentType').codes;
   
    const translator = useTranslator();

    const getTypelistName = useCallback((codeValue)=>{
        
        const typecode = _.find(typelistCodes, {code: codeValue});

        return (!_.isUndefined(typecode) ? translator({ id: typecode.name, defaultMessage: typecode.code}): null);
    }, [translator, typelistCodes])

    return {
        getTypelistName
    };

}

export default useTypelistUtil;